<template>
    <div class="checkin-popover" @click.stop>
        <div class="popover-header">Check-Ins</div>
        <div
            v-for="checkIn in checkIns.value"
            :key="checkIn.id"
            class="checkin-item"
            :class="{ unacked: !checkIn.ackAt }"
            v-contact-hover="{ id: checkIn.crmContactId, ...checkIn.contact }"
            @click="handleCheckInClick(checkIn)"
        >
            <Avatar :contact="{ id: checkIn.crmContactId, ...checkIn.contact }" size="xs" />
            <div class="checkin-info">
                <div class="checkin-name">{{ crmGetContactDisplayName(checkIn.contact ?? {}) || 'Unknown' }}</div>
                <div class="checkin-time">{{ $filters.dateTimeFriendly(checkIn.createdAt) }}</div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { nextTick, onMounted, ref, type Ref } from 'vue';
import { useRouter } from 'vue-router';

import type { ICrmCheckInResponse } from '@/openapi-clients-generated/suite';

import { vContactHover } from '@/modules/crm/exports/contact-hover.directive';
import { crmGetContactDisplayName } from '@/modules/crm/exports/contact.helpers';
import { SuiteCrmCheckInsApi } from '@/openapi-clients-generated/suite';
import Avatar from '@/shared/components/avatar.vue';

const props = defineProps<{
    checkIns: Ref<ICrmCheckInResponse[]>;
    callback: () => void;
}>();

const router = useRouter();

function handleCheckInClick(checkIn: ICrmCheckInResponse) {
    const now = new Date().toISOString();
    const unacked = props.checkIns.value.filter(c => c.crmContactId === checkIn.crmContactId && !c.ackAt);
    for (const c of unacked) {
        c.ackAt = now;
        SuiteCrmCheckInsApi.putCrmCheckInsAck({ path: { id: c.id } });
    }
    props.callback();
    router.push(`/crm/${checkIn.crmContactId}`);
}
</script>

<style scoped>
@reference '#tw.css';

.checkin-popover {
    @apply bg-surface rounded-lg shadow-lg border border-line min-w-72 max-h-[500px] overflow-y-auto;
}

.popover-header {
    @apply px-4 py-2 font-semibold text-ink border-b border-line;
}

.checkin-item {
    @apply flex items-center gap-3 px-4 py-2 cursor-pointer hover:bg-surface-2 border-b border-line last:border-b-0;
}

.checkin-item.unacked {
    @apply bg-warn-soft;
}

.checkin-info {
    @apply flex flex-col min-w-0;
}

.checkin-name {
    @apply text-base font-medium text-ink truncate;
}

.checkin-time {
    @apply text-sm text-ink-3;
}
</style>
